import React, { memo } from 'react';
import CircularProgressWithLabel from 'components/mui/CircularProgressWithLabel';
import { CarModel } from 'models/StockModel';
import { calcReadiness } from 'modules/cars/utils/common';


type CarReadinessGaugeProps = {
    car: CarModel,
}

const CarReadinessGauge = ({car}: CarReadinessGaugeProps) => {
    return (
        <CircularProgressWithLabel value={calcReadiness(car)}/>
    );
};

export default memo(CarReadinessGauge);
